import { useContext } from 'react';
import { createContext } from 'react';

import { VideoProps } from '../@types/VideoProps';

export const VideoContext = createContext<VideoProps>({} as VideoProps);

VideoContext.displayName = 'Video';

const VideoProvider = (props: VideoProps) => (
	<VideoContext.Provider value={props}>{props.children}</VideoContext.Provider>
);

export const useVideo = () => {
	const context = useContext(VideoContext);

	return context;
};

export default VideoProvider;
